import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css' ;
import {Button, Card, Col, Container, Row, Stack} from 'react-bootstrap';


//"https://itunes.apple.com/app/id1603225888"

function App() {
    return (
        <div className="App">    
            <Container>
                <Row className="justify-content-md-center">
                    <Col xs={12} md={6}>
                        <Card>
                            <Card.Img variant="top" src="logo_circle_green.png"
                                      style={{width: '30%', marginLeft: 'auto', marginRight: 'auto'}}/>
                            <Card.Body>
                                <Card.Title>SQUID WALLET</Card.Title>
                                <br/>
                                <Card.Text>
                                    ✅ Welcome!!!<br/>
                                    SQUID is a token based on Klaytn.<br/>
                                    Our development team wants the SQUID Token to be freely used in various places.<br/>
                                </Card.Text>
                                <Card.Text>
                                    ✔️ We will include short advertisements for service operation for the time
                                    being.<br/>
                                    ✔️ Run the app every day to get rewards.<br/>
                                    ✔️ Enter your referral code and get more rewards.
                                </Card.Text>
                                <Card.Text>
                                    Now send and receive SQUID with your friends!
                                    Have a good day. 🥳👋
                                </Card.Text>
                                <Stack gap={2}>
                                    <Button variant="success"
                                            href={"https://play.google.com/store/apps/details?id=com.blues.nab.squid_wallet"}>Download
                                        Android</Button>
                                    <Button variant="dark"
                                            onClick={() => alert('We are working hard to register the iOS app!!')}>Download
                                        iOS</Button>
                                </Stack>
                                <Button variant="link"
                                        href={"mailto:blues.nab@gmail.com"}>Contact us</Button>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default App;
